import { useTheme } from '@pata-app/themes';
import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { testimonialOptions, Testimoninal } from '../../../../components/testimoninal/testimoninal';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';

const TestimoninalTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        Why <strong>dog trainers </strong>
        trust Pata booking software
      </h2>
    </TextWithHighlight>
  );
};

const TestimoninalSubTitle = () => {
  return (
    <p style={{ maxWidth: '850px' }}>
      We think our booking platform can make a world of difference, but don't just take our word for it. Here's why dog
      trainers love using Pata to manage bookings, reduce admin and grow their business.
    </p>
  );
};

export function TrainerTestimoninal() {
  const theme = useTheme();

  const trainerTestimoninalConfig = [
    {
      children: testimonialOptions.talk_of_the_dog,
      color: theme.core.colors.primary.green.medium,
    },
  ];

  return (
    <WidthContainer noBackground>
      <SectionContainer title={TestimoninalTitle} subTitle={TestimoninalSubTitle}>
        <Testimoninal testimonialConfig={trainerTestimoninalConfig} />
      </SectionContainer>
    </WidthContainer>
  );
}
